










import { Component, Vue } from "vue-property-decorator";
import History from "@/components/geschiedenis/History.vue";
import HistorySenioren from "@/components/geschiedenis/HistorySenioren.vue";

@Component({
    components: { HistorySenioren, History }
})
export default class Geschiedenis extends Vue {}
